/** Utah's words for locationhealth.ts: the next-inspection lines. */
export const LOCATIONHEALTH_UT = {
  /** How often a food truck is inspected (Utah R392-102-16(10)(b): at least once each permit year). */
  nextInspectionTruck: "Next inspection: at least once each permit year (R392-102-16(10)(b)). The health department picks the date.",
  /** Who sets the next inspection date when we don't know it (Utah: the county health departments). */
  nextInspectionCountySets: "Utah counties set it.",
} as const;
